import React from 'react';

const LogoPACER = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#1F2937"/>
    <path d="M12 14C12 12.8954 12.8954 12 14 12H34C35.1046 12 36 12.8954 36 14V34C36 35.1046 35.1046 36 34 36H14C12.8954 36 12 35.1046 12 34V14Z" fill="white"/>
    <path d="M16 18H32" stroke="#1F2937" strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 24H32" stroke="#1F2937" strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 30H28" stroke="#1F2937" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="34" cy="30" r="4" fill="#EF4444"/>
  </svg>
);

export default LogoPACER;
